import React, { useContext, useState, useEffect } from "react";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Groups } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import * as XLSX from "xlsx";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";

import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray, isEmpty } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { PageHeader, Section, StatCard } from "../../components/ui";
import OnboardingChecklist from "../../components/OnboardingChecklist";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { formatDuration } from "../../components/SlaChip";
import SpeedOutlinedIcon from "@material-ui/icons/SpeedOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import { getTokens, brandAlpha, INK } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const sectionInk = t.mode === "dark" ? t.text : INK[700];
  return {
    scroll: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      ...theme.scrollbarStyles,
    },
    page: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
      maxWidth: 1280,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      paddingBottom: theme.spacing(2),
    },
    pageHeader: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    section: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1.5),
    },
    sectionTitle: {
      ...t.type.sectionTitle,
      fontSize: 15,
      color: sectionInk,
      lineHeight: 1.4,
    },
    sectionHint: {
      fontSize: 12,
      color: t.textMuted,
      marginTop: 1,
    },
    panel: {
      height: "100%",
      boxSizing: "border-box",
    },
    meterList: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    meterRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: theme.spacing(1),
    },
    meterLabel: {
      ...t.type.label,
      color: t.textSecondary,
    },
    meterValue: {
      fontSize: 14,
      fontWeight: 600,
      fontVariantNumeric: "tabular-nums",
      color: t.text,
    },
    meterTrack: {
      height: 8,
      borderRadius: 999,
      overflow: "hidden",
    },
    meterBar: {
      height: "100%",
      borderRadius: 999,
      transition: "width 250ms ease",
    },
    ratingValue: {
      fontSize: 30,
      fontWeight: 600,
      lineHeight: 1.1,
      letterSpacing: "-1px",
      fontVariantNumeric: "tabular-nums",
      color: t.text,
      margin: 0,
    },
    ratingHint: {
      fontSize: 13,
      color: t.textSecondary,
      margin: "6px 0 16px",
    },
    ratingScale: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: 6,
      fontSize: 12,
      color: t.textMuted,
      fontVariantNumeric: "tabular-nums",
    },
  };
});

const Meter = ({ label, value, color, classes, t }) => {
  const safe = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div>
      <div className={classes.meterRow}>
        <Typography component="span" className={classes.meterLabel}>
          {label}
        </Typography>
        <Typography component="span" className={classes.meterValue}>
          {value}%
        </Typography>
      </div>
      <div
        className={classes.meterTrack}
        style={{ backgroundColor: brandAlpha(color, t.mode === "dark" ? 0.22 : 0.14) }}
      >
        <div
          className={classes.meterBar}
          style={{ width: `${safe}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};

const SectionTitle = ({ title, hint, classes }) => (
  <div>
    <Typography component="h2" className={classes.sectionTitle}>
      {title}
    </Typography>
    {hint && (
      <Typography component="p" className={classes.sectionHint}>
        {hint}
      </Typography>
    )}
  </div>
);

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);
  const [slaReport, setSlaReport] = useState(null);

  const { user } = useContext(AuthContext);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;

    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
      }
    }

    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  async function fetchSlaReport(params) {
    // Mesmo período do dashboard; fila do filtro (false = todas)
    const slaParams = {};
    if (params.days) {
      slaParams.date_from = moment().subtract(params.days, "days").format("YYYY-MM-DD");
      slaParams.date_to = moment().format("YYYY-MM-DD");
    } else {
      if (params.date_from) slaParams.date_from = params.date_from;
      if (params.date_to) slaParams.date_to = params.date_to;
    }
    if (queueTicket) slaParams.queueId = queueTicket;
    try {
      const { data } = await api.get("/sla/report", { params: slaParams });
      setSlaReport(data && Number(data.total) > 0 ? data : null);
    } catch (err) {
      // rota pode não existir ainda (backend em paralelo) — esconde a seção
      setSlaReport(null);
    }
  }

  async function fetchData() {
    setLoading(true);
    console.log('Iniciando fetchData...');

    let params = {};

    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
        params = {
          ...params,
          date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', dateStartTicket);
      }

      if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
        params = {
          ...params,
          date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', dateEndTicket);
      }
    }

    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }

    console.log('Parâmetros finais para busca:', params);

    fetchSlaReport(params);

    try {
      const data = await find(params);
      console.log('Dados recebidos no componente:', data);

      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};

      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);

      setCounters(safeCounters);

      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }

      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);

      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error('Erro ao carregar dados do dashboard');

      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
    } finally {
      setLoading(false);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    return moment().startOf("day").add(minutes, "minutes").format("HH[h] mm[m]");
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  const indicators = [
    { label: "Em Atendimento", value: counters.supportHappening || 0, icon: <CallIcon />, tone: "brand" },
    { label: "Aguardando", value: counters.supportPending || 0, icon: <HourglassEmptyIcon />, tone: "warning" },
    { label: "Finalizados", value: counters.supportFinished || 0, icon: <CheckCircleIcon />, tone: "success" },
    { label: "Grupos", value: counters.supportGroups || 0, icon: <Groups />, tone: "info" },
    { label: "Atendentes Ativos", value: `${GetUsers()}/${attendants.length}`, icon: <RecordVoiceOverIcon />, tone: "brand" },
    { label: "Novos Contatos", value: counters.leads || 0, icon: <GroupAddIcon />, tone: "success" },
    { label: "Mensagens Recebidas", value: `${GetMessages(false, false)}/${GetMessages(true, false)}`, icon: <MessageIcon />, tone: "info" },
    { label: "Mensagens Enviadas", value: `${GetMessages(false, true)}/${GetMessages(true, true)}`, icon: <SendIcon />, tone: "brand" },
    { label: "T.M. de Atendimento", value: formatTime(counters.avgSupportTime), icon: <AccessAlarmIcon />, tone: "neutral" },
    { label: "T.M. de Espera", value: formatTime(counters.avgWaitTime), icon: <TimerIcon />, tone: "warning" },
    { label: "Tickets Ativos", value: counters.activeTickets || 0, icon: <ArrowUpward />, tone: "brand" },
    { label: "Tickets Passivos", value: counters.passiveTickets || 0, icon: <ArrowDownward />, tone: "neutral" },
  ];

  const npsMeters = [
    { label: "Score", value: counters.npsScore || 0, color: t.brand },
    { label: "Promotores", value: counters.npsPromotersPerc || 0, color: t.semantic.success },
    { label: "Neutros", value: counters.npsPassivePerc || 0, color: t.semantic.warning },
    { label: "Detratores", value: counters.npsDetractorsPerc || 0, color: t.semantic.error },
  ];

  const attendanceInfo = [
    { label: "Total de Atendimentos", value: counters.tickets || 0, icon: <CallIcon />, tone: "brand" },
    { label: "Atendimentos aguardando avaliação", value: counters.waitRating || 0, icon: <HourglassEmptyIcon />, tone: "warning" },
    { label: "Atendimentos sem avaliação", value: counters.withoutRating || 0, icon: <StarBorderIcon />, tone: "error" },
    { label: "Atendimentos avaliados", value: counters.withRating || 0, icon: <StarIcon />, tone: "success" },
  ];

  const pctTone = (pct) => (pct >= 90 ? "success" : pct >= 70 ? "warning" : "error");
  const slaCards = slaReport
    ? [
        {
          label: i18n.t("sla.dashboard.pctFirst"),
          value: `${Math.round(Number(slaReport.pctFirst) || 0)}%`,
          hint: `${slaReport.withinFirst || 0}/${slaReport.total || 0}`,
          icon: <SpeedOutlinedIcon />,
          tone: pctTone(Number(slaReport.pctFirst) || 0),
        },
        {
          label: i18n.t("sla.dashboard.pctResolution"),
          value: `${Math.round(Number(slaReport.pctResolution) || 0)}%`,
          hint: `${slaReport.withinResolution || 0}/${slaReport.total || 0}`,
          icon: <AssignmentTurnedInOutlinedIcon />,
          tone: pctTone(Number(slaReport.pctResolution) || 0),
        },
        {
          label: i18n.t("sla.dashboard.avgFirstResponse"),
          value: formatDuration(slaReport.avgFirstResponseSec || 0),
          icon: <TimerIcon />,
          tone: "info",
        },
        {
          label: i18n.t("sla.dashboard.avgResolution"),
          value: formatDuration(slaReport.avgResolutionSec || 0),
          icon: <AccessAlarmIcon />,
          tone: "neutral",
        },
      ]
    : [];

  const percRating = Math.max(0, Math.min(100, Number(counters.percRating) || 0));
  const percRatingLabel =
    Number(counters.percRating / 100).toLocaleString(undefined, { style: "percent" }) || "0%";

  return (
    <>
      {user.profile === "user" && user.showDashboard === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <MainContainer>
          <div className={classes.scroll}>
            <div className={classes.page}>
              {/* CABEÇALHO */}
              <PageHeader
                className={classes.pageHeader}
                title="Dashboard"
                subtitle="Visão geral dos atendimentos, avaliações e equipe"
                actions={
                  <Button
                    variant="outlined"
                    onClick={toggleShowFilter}
                    aria-expanded={showFilter}
                    startIcon={!showFilter ? <FilterListIcon /> : <ClearIcon />}
                  >
                    {showFilter ? "Ocultar Filtros" : "Mostrar Filtros"}
                  </Button>
                }
              />

              {/* PRIMEIROS PASSOS (admin, enquanto faltar algo) */}
              {user.profile === "admin" && <OnboardingChecklist />}

              {/* FILTROS */}
              {showFilter && (
                <Filters
                  classes={classes}
                  setDateStartTicket={setDateStartTicket}
                  setDateEndTicket={setDateEndTicket}
                  dateStartTicket={dateStartTicket}
                  dateEndTicket={dateEndTicket}
                  setQueueTicket={setQueueTicket}
                  queueTicket={queueTicket}
                  fetchData={setFetchDataFilter}
                />
              )}

              {/* Indicadores Gerais */}
              <section className={classes.section}>
                <SectionTitle
                  title="Indicadores"
                  hint="Situação atual dos atendimentos no período filtrado"
                  classes={classes}
                />
                <Grid2 container spacing={2}>
                  {indicators.map((indicator, index) => (
                    <Grid2 xs={12} sm={6} md={4} lg={3} key={index}>
                      <StatCard
                        label={indicator.label}
                        value={indicator.value}
                        icon={indicator.icon}
                        tone={indicator.tone}
                      />
                    </Grid2>
                  ))}
                </Grid2>
              </section>

              {/* SLA */}
              {slaReport && (
                <section className={classes.section}>
                  <SectionTitle
                    title={i18n.t("sla.dashboard.title")}
                    hint={`${i18n.t("sla.dashboard.hint")} · ${i18n.t("sla.dashboard.total", { count: slaReport.total })}`}
                    classes={classes}
                  />
                  <Grid2 container spacing={2}>
                    {slaCards.map((c) => (
                      <Grid2 xs={12} sm={6} md={3} key={c.label}>
                        <StatCard label={c.label} value={c.value} hint={c.hint} icon={c.icon} tone={c.tone} />
                      </Grid2>
                    ))}
                  </Grid2>
                </section>
              )}

              {/* Informações de Atendimento */}
              <section className={classes.section}>
                <SectionTitle
                  title="Atendimentos"
                  hint="Avaliações pedidas e recebidas no período"
                  classes={classes}
                />
                <Grid2 container spacing={2}>
                  {attendanceInfo.map((attInfo, index) => (
                    <Grid2 xs={12} sm={6} md={3} key={index}>
                      <StatCard
                        label={attInfo.label}
                        value={attInfo.value}
                        icon={attInfo.icon}
                        tone={attInfo.tone}
                      />
                    </Grid2>
                  ))}
                </Grid2>
              </section>

              {/* Pesquisa de Satisfação (NPS) + Índice de Avaliação */}
              <Grid2 container spacing={2}>
                <Grid2 xs={12} md={7}>
                  <Section title="Pesquisa de satisfação (NPS)" className={classes.panel}>
                    <div className={classes.meterList}>
                      {npsMeters.map((meter) => (
                        <Meter
                          key={meter.label}
                          label={meter.label}
                          value={meter.value}
                          color={meter.color}
                          classes={classes}
                          t={t}
                        />
                      ))}
                    </div>
                  </Section>
                </Grid2>
                <Grid2 xs={12} md={5}>
                  <Section title="Índice de avaliação" className={classes.panel}>
                    <p className={classes.ratingValue}>{percRatingLabel}</p>
                    <p className={classes.ratingHint}>Percentual de atendimentos avaliados</p>
                    <div
                      className={classes.meterTrack}
                      style={{ backgroundColor: t.tint.soft }}
                      role="progressbar"
                      aria-valuenow={percRating}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className={classes.meterBar}
                        style={{ width: `${percRating}%`, backgroundColor: t.brand }}
                      />
                    </div>
                    <div className={classes.ratingScale}>
                      <span>0%</span>
                      <span>100%</span>
                    </div>
                  </Section>
                </Grid2>
              </Grid2>

              {/* Tabela de Atendentes */}
              <Section title="Atendentes" flush>
                <TableAttendantsStatus
                  attendants={attendants}
                  loading={loading}
                />
              </Section>

              {/* Gráficos */}
              <Grid2 container spacing={2}>
                <Grid2 xs={12} md={6}>
                  <ChatsUser />
                </Grid2>
                <Grid2 xs={12} md={6}>
                  <ChartsDate />
                </Grid2>
              </Grid2>
            </div>
          </div>
        </MainContainer>
      )}
    </>
  );
};

export default Dashboard;
